import React, { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { API_URL, useAxios } from "../../../../../utils/const";
import { useToast } from "../../../../../Context/ToastContext";
import { useForm } from "react-hook-form";
import { Message } from "primereact/message";
import imageCompression from "browser-image-compression";

const CheckInStudentModal = ({
  toggleModal,
  getCourseSession,
  location,
  checkInTime,
  student,
  setCheckInStatus,
  courseId,
}) => {
  const axiosInstance = useAxios();
  const { setToastObj } = useToast();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      id: student.student[0].id,
      course_type: student.course_type,
      latitude: location.latitude,
      longitude: location.longitude,
      check_in: checkInTime,
    },
  });

  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    toggleModal(false);
  };

  const handleSave = async (formData) => {
    setLoading(true);

    try {
      // Dapatkan file gambar asli
      const originalImage = formData.image[0];

      // Kompres gambar
      const options = {
        maxSizeMB: 0.2, // Ukuran maksimum file dalam MB
        maxWidthOrHeight: 800, // Dimensi maksimum dalam pixel
        useWebWorker: true,
      };
      const compressedImage = await imageCompression(originalImage, options);

      const data = {
        id: formData.id,
        course_type: formData.course_type,
        latitude: formData.latitude.toString(),
        longitude: formData.longitude.toString(),
        check_in: formData.check_in,
        image: compressedImage, // Gambar yang telah dikompres
      };

      const getCurrentTime = async () => {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, "0"); // Add leading zero if needed
        const minutes = String(now.getMinutes()).padStart(2, "0"); // Add leading zero if needed
        return `${hours}:${minutes}`;
      };
      const currentTime = await getCurrentTime();
      const checkInMessage = `Berhasil masuk pada pukul ${currentTime}`;
      const statusData = {
        id: courseId, // ID
        status: checkInMessage, // Status check-in
      };

      const fileData = new FormData();
      fileData.append("data", JSON.stringify(data));
      fileData.append("image", compressedImage);

      // Kirim data ke server
      await axiosInstance.put(
        `${API_URL}/course-attendances/student/check-in/${formData.id}/${formData.course_type}`,
        fileData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setCheckInStatus(checkInMessage);
      localStorage.setItem("checkInStatus", JSON.stringify(statusData));
      getCourseSession();
      setLoading(false);
      setToastObj({ msg: "Data Berhasil ditambahkan", type: "success" });
      closeModal();
    } catch (error) {
      let errorMessage = "Terjadi kesalahan";
      if (error.response?.data?.msg !== undefined) {
        errorMessage = `Terjadi kesalahan, ${error.response.data.msg}`;
      } else {
        errorMessage = error.message;
      }
      setLoading(false);
      setToastObj({
        msg: errorMessage,
        type: "danger",
      });
      closeModal();
    }
  };

  return (
    <Modal show={toggleModal} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h6>Absen Masuk</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group mb-3">
          <label className="form-label">Upload Foto</label>
          <input
            {...register("image", {
              required: "Foto tidak boleh kosong!",
            })}
            type="file"
            className="form-control"
            accept="image/*"
            capture="camera"
          />
          {errors.image && (
            <div className="">
              <Message
                className="mt-2 d-flex"
                severity="error"
                text={errors.image.message}
              />
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          Batal
        </Button>
        <Button
          variant="success"
          disabled={loading}
          onClick={handleSubmit(handleSave)}
        >
          {loading && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          )}
          <span className="ml-1">Simpan</span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CheckInStudentModal;
